import { GetStockItem_stockItem_withdrawal } from "api/Medicine/types/GetStockItem";

export const getMedicineWithdrawalsAsString = (
  withdrawal: (GetStockItem_stockItem_withdrawal | null)[] | null,
): string => {
  if (!withdrawal || !withdrawal.length) return "";

  return withdrawal
    ?.map((item) => `${item?.animalType?.name}(${item?.withdrawalType}): ${item?.withdrawalPeriodDays} days`)
    .join(", ");
};
